export default __webpack_public_path__ + "static/media/Conconi.1d823810.jpg";